import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeMocks';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            浏览素材分类
          </h2>
          <p className="mt-3 text-foreground-600 max-w-lg mx-auto">
            覆盖游戏开发全流程的素材分类，从美术到音效，一站满足您的所有创作需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${
                    cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                    cat.color === 'accent' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                </div>
                <p className="text-sm text-foreground-600 mb-2">{cat.description}</p>
                <span className="text-xs text-foreground-400">{cat.count.toLocaleString()} 款素材</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}